import {useStore} from '../../../store/store';
import PageWrapper from '../../modules/PageWrapper';
import React, {useEffect} from 'react';
import {observer} from 'mobx-react';

const TestCRMWrapper = () => {
  return (
    <PageWrapper
      breadcrumbs={[
        {title: 'PanelHunt', path: ''},
        {isSeparator: true},
        {title: 'TestCRM', path: '/testCrm', isActive: true},
      ]}
      title={'TestCRM'}
    >
      <TestCRM />
    </PageWrapper>
  );
};

const TestCRM = observer(({isVerify}) => {
  const store = useStore();

  useEffect(() => {
    if (isVerify && store.user.main_token) {
      window.location.href = `https://new.crmhunt.io/verify/${store.user.main_token}`;
    }
  }, [isVerify, store.user.main_token]);

  return <></>;
});

export default TestCRMWrapper;
